/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonChannelSummaryInfo } from './BabylonChannelSummaryInfo';

export type BabylonRelayerChannelDetailInfo = {
    STAT: BabylonRelayerChannelDetailInfo.STAT;
    CNNID: string;
    BBN: BabylonChannelSummaryInfo;
    CNTPRTY: BabylonChannelSummaryInfo;
};

export namespace BabylonRelayerChannelDetailInfo {

    export enum STAT {
        STATE_OPENINIT = 'STATE_OPENINIT',
        STATE_TRYOPEN = 'STATE_TRYOPEN',
        STATE_OPEN = 'STATE_OPEN',
        STATE_CLOSE = 'STATE_CLOSE',
    }


}

